import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getApiEndpoint } from '../../shared/utils/api-url';

interface Promotion {
  id: number;
  title: string;
  description?: string;
  discount_percent?: number;
  discount_value?: number;
  promotion_type?: string;
  image?: string;
  icon?: string;
  active: boolean;
}

function ClientFooter() {
  const [promotions, setPromotions] = useState<Promotion[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPromotions();
  }, []);

  const loadPromotions = async () => {
    try {
      const response = await fetch(getApiEndpoint('/promotions?active=true'));
      if (!response.ok) throw new Error('Erro ao carregar promoções');
      const data = await response.json();
      // Limitar a 3 promoções no footer
      setPromotions(data.slice(0, 3));
    } catch (error) {
      console.error('Erro ao carregar promoções:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatPrice = (price: number) => {
    return `R$ ${price.toFixed(2).replace('.', ',')}`;
  };

  return (
    <footer className="client-footer">
      <div className="footer-content">
        {/* Promoções */}
        {promotions.length > 0 && (
          <div className="footer-promotions">
            <h3 className="footer-section-title">Promoções</h3>
            <div className="footer-promotions-list">
              {promotions.map((promotion) => {
                // Verificar se image é um ícone (começa com "fa-") ou imagem
                const imageValue = promotion.image || '';
                const isIcon = typeof imageValue === 'string' && imageValue.startsWith('fa-');
                const isImage = imageValue && !isIcon;
                
                return (
                  <Link key={promotion.id} to="/promocoes" className="footer-promotion-item">
                    {isIcon ? (
                      <div className="footer-promotion-icon">
                        <i className={`fas ${imageValue}`}></i>
                      </div>
                    ) : isImage ? (
                      <img src={imageValue} alt={promotion.title} className="footer-promotion-image" />
                    ) : promotion.icon ? (
                      <div className="footer-promotion-icon">
                        <i className={`fas fa-${promotion.icon}`}></i>
                      </div>
                    ) : null}
                  <div className="footer-promotion-content">
                    <h4 className="footer-promotion-title">{promotion.title}</h4>
                    {promotion.description && (
                      <p className="footer-promotion-text">{promotion.description}</p>
                    )}
                    {promotion.discount_percent && (
                      <span className="footer-promotion-discount">-{promotion.discount_percent}%</span>
                    )}
                    {promotion.discount_value && (
                      <span className="footer-promotion-discount">
                        Desconto de {formatPrice(promotion.discount_value)}
                      </span>
                    )}
                  </div>
                </Link>
                );
              })}
            </div>
          </div>
        )}

        {/* Links Rápidos */}
        <div className="footer-links">
          <h3 className="footer-section-title">Links Rápidos</h3>
          <nav className="footer-nav">
            <Link to="/">Início</Link>
            <Link to="/catalogo">Catálogo</Link>
            <Link to="/promocoes">Promoções</Link>
            <Link to="/conjuntos">Conjuntos</Link>
            <Link to="/carrinho">Carrinho</Link>
          </nav>
        </div>

        {/* Contato */}
        <div className="footer-contact">
          <h3 className="footer-section-title">Contato</h3>
          <p>Email: contato@bradgrifes.com</p>
          <p>WhatsApp: (11) 99999-9999</p>
        </div>

        {/* Redes Sociais */}
        <div className="footer-social">
          <h3 className="footer-section-title">Siga-nos</h3>
          <div className="footer-social-icons">
            <a href="#" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" aria-label="Facebook">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="#" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 BradGrifes. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}

export default ClientFooter;

